import {useEffect, useRef, useState} from "react";
import './CreditsOverlay.scss';
import BouncyText from "../../components/bouncy-text/BouncyText";

interface CreditsOverlayState {
    followers: string[],
    subscribers: string[],
    gifts: { [username: string]: number },
    cheers: { [username: string]: number },
    raids: { [username: string]: number },
    donations: { [username: string]: number },
    sponsorPatrons: string[],
    supporterPatrons: string[],
    patrons: string[]
}

const TestCreditsOverlay = () => {

    const initialState = {followers: [], subscribers: [], gifts: {}, cheers: {}, raids: {}, donations: {},
        sponsorPatrons: [], supporterPatrons: [], patrons: []};

    const credits = useRef<CreditsOverlayState>({...initialState});
    const [fetchedEvents, setFetchedEvents] = useState<boolean>(false);
    const [fetchedPatrons, setFetchedPatrons] = useState<boolean>(false);

    useEffect(() => {
        credits.current = {
            followers: ["testUser", "newFollower", "x_twitch_x"],
            subscribers: ["subbie", "newSubscriber", "hi"],
            gifts: {
                testGifter: 5,
                testGifter2: 1,
            },
            cheers: {
                testBitter: 100,
                cheerleader: 10
            },
            raids: {
                raider1: 20,
                raiderDude: 12
            },
            donations: {
                donoArigato: 100,
                bigDonoMan: 10000
            },
            sponsorPatrons: ["sponsor1", "patron2"],
            supporterPatrons: ["supporter3", "patron4"],
            patrons: ["patron5", "patron6", "patronX"]
        };
        setFetchedEvents(true);
        setFetchedPatrons(true);
    }, []);

    return (fetchedEvents && fetchedPatrons) ? <>
        <div className="credits-overlay">
            <div className="credits-overlay-text">
                <h1>Credits</h1>
                {fetchedEvents && credits.current.followers.length > 0 && <>
                    <h2>New Followers</h2>
                    {credits.current.followers.sort().map(follower => <p key={`follower-${follower}`}>{follower}</p>)}
                </>}
                {fetchedEvents && Object.keys(credits.current.raids).length > 0 && <>
                    <h2>Raiders</h2>
                    {Object.keys(credits.current.raids)
                        .sort((a, b) => credits.current.raids[b] - credits.current.raids[a])
                        .map(raider => <p key={`raider-${raider}`}>{raider} - {credits.current.raids[raider]}</p>)}
                </>}
                {fetchedEvents && Object.keys(credits.current.gifts).length > 0 && <>
                    <h2>Gifters</h2>
                    {Object.keys(credits.current.gifts)
                        .sort((a, b) => credits.current.gifts[b] - credits.current.gifts[a])
                        .map(gifter => <p key={`gifter-${gifter}`}>{gifter} - {credits.current.gifts[gifter]}</p>)}
                </>}
                {fetchedEvents && Object.keys(credits.current.cheers).length > 0 && <>
                    <h2>Cheerers</h2>
                    {Object.keys(credits.current.cheers)
                        .sort((a, b) => credits.current.cheers[b] - credits.current.cheers[a])
                        .map(cheerer => <p key={`cheer-${cheerer}`}>{cheerer} - {credits.current.cheers[cheerer]}</p>)}
                </>}
                {fetchedEvents && credits.current.subscribers.length > 0 && <>
                    <h2>Subscribers</h2>
                    {credits.current.subscribers.sort().map(subscriber => <p key={`sub-${subscriber}`}>{subscriber}</p>)}
                </>}
                {fetchedEvents && Object.keys(credits.current.donations).length > 0 && <>
                    <h2>Charitable Donations</h2>
                    {Object.keys(credits.current.donations)
                        .sort((a, b) => credits.current.donations[b] - credits.current.donations[a])
                        .map(donor => <p key={`donor-${donor}`}>{donor} - {credits.current.donations[donor]}</p>)}
                </>}
                {fetchedPatrons && credits.current.sponsorPatrons.length > 0 && <>
                    <h2><BouncyText className="rainbow" text={'Sponsor Tier Patreon Members!'}/></h2>
                    {credits.current.sponsorPatrons.sort().map(patron => <p key={`sponsor-${patron}`}>{patron}</p>)}
                </>}
                {fetchedPatrons && credits.current.supporterPatrons.length > 0 && <>
                    <h2><BouncyText className="orange" text={"Supporter Tier Patreon Members"}/></h2>
                    {credits.current.supporterPatrons.sort().map(patron => <p key={`supporter-${patron}`}>{patron}</p>)}
                </>}
                {fetchedPatrons && credits.current.patrons.length > 0 && <>
                    <h2><BouncyText text={"Patron Tier Patreon Members"}/></h2>
                    {credits.current.patrons.sort().map(patron => <p key={`patron-${patron}`}>{patron}</p>)}
                </>}
                <h2>
                    Join the Patreon to see your name here!<br/>
                    <span className="blue">patreon.com/chasethefox</span>
                </h2>
            </div>
        </div>
    </> : <></>;
}

export default TestCreditsOverlay;